export const VARIANT_URL_KEY: string = 'odp.variantApiUrl';
export const BANNER_MSG_KEY: string = 'banner-msg';
